module.exports = __webpack_public_path__ + "img/service1.e4f80fd4.png";